import React from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import TextField from '@material-ui/core/TextField';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import { Paper } from "@material-ui/core";
import NumberFormat from 'react-number-format';
import moment from 'moment';
import ls from 'local-storage'

const styles = theme => ({
    root: {
        flexGrow: 1,
        overflow: 'hidden',
    },
    paper: {
        padding: theme.spacing.unit,
        margin: theme.spacing.unit,
    },
    card: {
      minWidth: 275,
    },
    bullet: {
      display: 'inline-block',
      margin: '0 2px',
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 18,
      fontWeight: 'bold',
    },
    pos: {
      marginBottom: 12,
    },
    formControl: {
      margin: theme.spacing.unit,
    },
    group: {
      margin: `${theme.spacing.unit}px 0`,
    },
    formLabel: {
        textAlign: 'left',
    },
    formInput: {
        padding: 0,
    },
    greenradio: {
        color: green[600],
        '&$checked': {
            color: green[500],
        },
    },
    redradio: {
        color: red[600],
        '&$checked': {
            color: red[500],
        },
    },
    checked: {},
});


function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;
  
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={values => {
          onChange({
            target: {
              value: values.value,
            },
          });
        }}
        thousandSeparator
        prefix="£"
      />
    );
}

NumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
};

class ClaimENStep3 extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.props = props;
    }    

    state = {
        fp17data: this.props.fp17data,
        bands: [],
    };

    getbandList() {
        if (this._isMounted) {
            this.props.socket.emit("band_list",{startdate:this.state.fp17data.datacc,authenticator:ls.get("authenticator")});
        }        
    }

    async componentDidMount() {
        this._isMounted = true;

        await this.getbandList();

        this.props.socket.on("band_list_result",async (d)=> {
            if (this._isMounted) {
                await this.setState({bands:d});

                //console.log(this.state);

                await this.setBand(this.state.fp17data.claim_band);
            }
        }); 

    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    setBand(band) {
        //console.log('change', band);
        if (this._isMounted) {
            
            //console.log(this.state.fp17data);
            //console.log(this.state.bands);

            //this.setState({ [name]: event.target.value });
            let datatmp = this.state.fp17data;
            datatmp.claim_band = band;
            this.setState({fp17data: datatmp});  

            // set the ptchg depending on the band / category
            let i = 0;
            for (i=0; i<this.state.bands.length; i++)
            {
                //console.log(typeof(this.state.bands[i].uda_id) +'==='+ typeof(band));
                if (this.state.bands[i].uda_id.toString() === band) {
                    datatmp.pchg = this.state.bands[i].patient_charge;
                    break;
                }
            }

            //console.log(datatmp);

            // check to see if the chosen band causes a continuation
            //console.log({props: this.props.pdata});
            let continuations = this.props.pdata.continuations;
            let previous_claim = this.props.pdata.previous_claim;

            if (previous_claim.uda_id && this.state.fp17data.claim_band) {
                let datacc = this.state.fp17data.datacc;
                //first check the treatment dates are within 60 days
                // if no start date, assume it's today
                if (!datacc)
                    datacc = moment().format('YYYY-MM-DD');

                if (moment(datacc).diff(moment(previous_claim.datcp), 'days', false) < 60) {
                    i = 0;
                    for (i=0; i<continuations.length;i++) {
                        if ((continuations[i].new_band.toString() === this.state.fp17data.claim_band.toString()) && 
                            (continuations[i].from_band.toString() === previous_claim.uda_id.toString())) {
                                let datatmp = this.state.fp17data;
                                if (continuations[i].continuation === true) {
                                    datatmp.os9163 = 'y';
                                    datatmp.pchg = 0;                                    
                                } else {
                                    datatmp.os9163 = 'n';
                                }
                                this.setState({fp17data: datatmp});       
                                break;            
                        } else {
                            let datatmp = this.state.fp17data;
                            datatmp.os9163 = 'n';
                            this.setState({fp17data: datatmp});  
                        }
                    }
                }
            }


            // check to see if the exemption should change the patient charge
            // if there's a cert value, set the charge to that
            // otherwise if it's not a uda_id 10, set the pchg to 0
            if (this.state.fp17data.exrmcd === '5' && this.state.fp17data.exemp_limit) {
                if (this.state.fp17data.exemp_limit < datatmp.pchg)
                    datatmp.pchg = this.state.fp17data.exemp_limit;
            } else if (this.state.fp17data.exrmcd > 0 && this.state.fp17data.exrmcd !== '10')
                datatmp.pchg = 0;


            //console.log(datatmp);

            if (!this.state.fp17data.batch_id) {
            // remove cds entries if the claim hasn't been sent yet
                datatmp = this.state.fp17data;
                datatmp.cds9301 = undefined;
                datatmp.cds9302 = undefined;
                datatmp.cds9303 = undefined;
                datatmp.cds9304 = undefined;
                datatmp.cds9305 = undefined;
                datatmp.cds9306 = undefined;
                datatmp.cds9307 = undefined;
                datatmp.cds9308 = undefined;
                datatmp.cds9309 = undefined;
                datatmp.cds9310 = undefined;
                datatmp.cds9311 = undefined;
                datatmp.cds9312 = undefined;
                datatmp.cds9313 = undefined;
                datatmp.cds9314 = undefined;
                datatmp.cds9315 = undefined;
                datatmp.cds9316 = undefined;
                datatmp.cds9317 = undefined;
                datatmp.cds9318 = undefined;
                datatmp.cds9399 = undefined;
                datatmp.cds9370 = undefined;
                datatmp.cds9371 = undefined;
                datatmp.cds9379 = undefined;
            }
            
            this.setState({fp17data: datatmp});
        }
    }

    handleBandChange = name => event => {
        this.setBand(event.target.value);
    };

    handleChange = name => event => {
        //this.setState({ [name]: event.target.value });
        let datatmp = this.state.fp17data;
        datatmp[name] = event.target.value;
        this.setState({fp17data: datatmp});        

        //console.log(this.state);
    };    

    render() {
        const { classes } = this.props;

        return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                    Part 5 Treatment Category
                    </Typography>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <FormControl className={classes.formControl} fullWidth={true}>
                                <RadioGroup
                                    aria-label="Incomplete Treatment"
                                    name="claim-band"
                                    className={classes.group}
                                    value={this.state.fp17data.claim_band}
                                    onChange={this.handleBandChange()}
                                    row
                                >
                                    <FormControlLabel value="1" control={<Radio />} label="Band 1" />
                                    <FormControlLabel value="3" control={<Radio />} label="Band 2 (3 UDA)"/>
                                    <FormControlLabel value="31" control={<Radio />} label="Band 2b (5 UDA)" />
                                    <FormControlLabel value="32" control={<Radio />} label="Band 2c (7 UDA)" />
                                    <FormControlLabel value="4" control={<Radio />} label="Band 3" />
                                    <FormControlLabel value="2" control={<Radio />} label="Urgent treatment" />
                                    <FormControlLabel value="13" control={<Radio />} label="Band 6 - Triage" />
                                    <FormControlLabel value="10" control={<Radio />} label="Regulation 11" />
                                    
                                    <FormControlLabel value="5" control={<Radio />} label="Prescription Only" />
                                    <FormControlLabel value="6" control={<Radio />} label="Denture repairs" />
                                    <FormControlLabel value="7" control={<Radio />} label="Bridge repairs" />
                                    <FormControlLabel value="9" control={<Radio />} label="Arrest of bleeding" />
                                    <FormControlLabel value="8" control={<Radio />} label="Removal of sutures" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControl className={classes.formControl} fullWidth={false}>
                                <FormLabel  htmlFor="claim-pchg">Patient charge collected</FormLabel>
                                <TextField
                                    value={this.state.fp17data.pchg}
                                    onChange={this.handleChange('pchg')}
                                    id="claim-pchg"
                                    InputProps={{
                                        inputComponent: NumberFormatCustom,
                                    }}
                                />                                
                            </FormControl>                            
                        </Grid>
                    </Grid>
                    * Changing the Category will clear out the Clinical Data Set
            </Paper>           
        </div>
        );
    }
}

ClaimENStep3.propTypes = {
    classes: PropTypes.object.isRequired,
  };
  
  export default withStyles(styles)(ClaimENStep3);